export default __webpack_public_path__ + "assets/images/083ddc433c97adcd499ee1f7aa5dc7ac.svg";